export function parseFinite(value: string | number | null | undefined): number | undefined {
  if (value == null) return undefined
  const num = typeof value === 'number' ? value : parseFloat(value)
  return Number.isFinite(num) ? num : undefined
}

export function parseIntFinite(value: string | number | null | undefined): number | undefined {
  const num = parseFinite(value)
  if (num == null) return undefined
  return Math.trunc(num)
}

export function formatPercent(value: number): string {
  const format = Intl.NumberFormat('en', { maximumFractionDigits: 2 })
  return format.format(value) + '%'
}
